Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.StoreMode=exports.actions=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();

var _reduxOrm=require('redux-orm');
var _lodash=require('lodash');
var _utils=require('./utils');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_STORES:'UPSERT_STORES',
UPDATE_STORES:'UPDATE_STORES',
UPDATE_STORE:'UPDATE_STORE',
DELETE_STORE:'DELETE_STORE',
UPSERT_STORE:'UPSERT_STORE'};


var StoreMode=exports.StoreMode={
NORMAL:'normal',
EMERGENCY:'emergency'};var





Store=function(_Model){_inherits(Store,_Model);function Store(){_classCallCheck(this,Store);return _possibleConstructorReturn(this,(Store.__proto__||Object.getPrototypeOf(Store)).apply(this,arguments));}_createClass(Store,[{key:'toString',value:function toString()








































































{
return'Store: '+this.id;
}}],[{key:'reducer',value:function reducer(action,Store,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_STORE:{var store=action.payload.store;var storeExists=Store.hasId(store.id);if(storeExists){var oldStore=Store.withId(store.id);store=_extends({},oldStore.ref,store);}Store.upsert(store);break;}case actions.UPSERT_STORES:{var stores=action.payload.stores;stores.forEach(function(store){Store.upsert(store);});break;}case actions.UPDATE_STORES:{var _stores=action.payload.stores;var storesToRemove=Store.exclude(function(store){return _stores.find(function(_ref){var id=_ref.id;return store.id===id;});});storesToRemove.toModelArray().forEach(deleteRelatedChilds);storesToRemove.delete();_stores.forEach(function(s){var storeExists=Store.hasId(s.id);if(storeExists){var _store=Store.withId(s.id);checkRelatedChilds(_store,s);}Store.upsert(s);});break;}case actions.UPDATE_STORE:{var _store2=action.payload.store;var _storeExists=Store.hasId(_store2.id);if(_storeExists){var _oldStore=Store.withId(_store2.id);checkRelatedChilds(_oldStore,_store2);}Store.upsert(_store2);break;}case actions.DELETE_STORE:{var id=action.payload.id;Store.hasId(id)&&Store.withId(id).delete();break;}}return undefined;}}]);return Store;}(_reduxOrm.Model);exports.default=Store;

Store.modelName='Store';

Store.fields={
id:(0,_reduxOrm.attr)(),
name:(0,_reduxOrm.attr)(),
previewImageId:(0,_reduxOrm.attr)(),
latitude:(0,_reduxOrm.attr)(),
longitude:(0,_reduxOrm.attr)(),
state:(0,_reduxOrm.attr)(),
mode:(0,_reduxOrm.attr)(),
branchCode:(0,_reduxOrm.attr)(),
contactName:(0,_reduxOrm.attr)(),
contactEmail:(0,_reduxOrm.attr)(),
contactPhone:(0,_reduxOrm.attr)(),
createdAt:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
floorsCount:(0,_reduxOrm.attr)(),
areasCount:(0,_reduxOrm.attr)(),
fixturesCount:(0,_reduxOrm.attr)(),
positionsCount:(0,_reduxOrm.attr)(),
securityDevicesCount:(0,_reduxOrm.attr)(),
securedProductsCount:(0,_reduxOrm.attr)(),
noncompliantReason:(0,_reduxOrm.attr)(),
complianceStatus:(0,_reduxOrm.attr)(),
complianceStatusUpdatedAt:(0,_reduxOrm.attr)(),
healthStatus:(0,_reduxOrm.attr)(),
healthStatusUpdatedAt:(0,_reduxOrm.attr)(),
meta:(0,_reduxOrm.attr)(),
location:(0,_reduxOrm.attr)(),
hasImperialUnits:(0,_reduxOrm.attr)(),
noncompliantAt:(0,_reduxOrm.attr)(),
noncompliantNotifiedAt:(0,_reduxOrm.attr)(),
organizationId:(0,_reduxOrm.fk)('Organization','storeIds'),
storePhone:(0,_reduxOrm.attr)(),
timeZone:(0,_reduxOrm.attr)(),
timeZoneOffset:(0,_reduxOrm.attr)(),
floors:(0,_reduxOrm.attr)(),
areas:(0,_reduxOrm.attr)(),
fixtures:(0,_reduxOrm.attr)(),
storeRules:(0,_reduxOrm.attr)(),
address:(0,_reduxOrm.attr)(),
securedProducts:(0,_reduxOrm.attr)(),
securityDevices:(0,_reduxOrm.attr)(),
regionId:(0,_reduxOrm.attr)(),
ruleIds:(0,_reduxOrm.many)('Rule'),
imageId:(0,_reduxOrm.attr)(),
imageCollection:(0,_reduxOrm.attr)(),
allowedKeyTypes:(0,_reduxOrm.attr)()};


var upsertStores=function upsertStores(stores){
var objs=stores?filterObjs(stores):[];

return{
type:actions.UPSERT_STORES,
payload:{
stores:objs}};


};

var upsertStore=function upsertStore(store){
return{
type:actions.UPSERT_STORE,
payload:{store:store}};

};

var updateStores=function updateStores(stores){
var objs=stores?filterObjs(stores):[];

return{
type:actions.UPDATE_STORES,
payload:{
stores:objs}};


};

var updateStore=function updateStore(store){
if(!store)return;

var filteredStore=filterObjs([store])[0];

return{
type:actions.UPDATE_STORE,
payload:{
store:filteredStore}};


};

var filterObjs=function filterObjs(stores){return(
stores.map(function(s){
var store=_extends({},
s,{
floors:s.floorIds,
areas:s.areaIds,
fixtures:s.fixtureIds,
storeRules:s.storeRuleIds,
address:s.addressId,
securedProducts:s.securedProductIds,
securityDevices:s.securityDeviceIds});

return(0,_utils.filterInput)(Store)(store);
}));};

var deleteStoreWithId=function deleteStoreWithId(id){return{
type:actions.DELETE_STORE,
payload:{
id:id}};};



var creators=exports.creators={
upsertStores:upsertStores,
updateStores:updateStores,
deleteStoreWithId:deleteStoreWithId,
updateStore:updateStore,
upsertStore:upsertStore};


var checkRelatedChilds=function checkRelatedChilds(oldStore,newStore){
checkRelationshipsToFloorsAndDeleteOld(oldStore,newStore);
checkRelationshipsToAreasAndDeleteOld(oldStore,newStore);
checkRelationshipsToFixturesAndDeleteOld(oldStore,newStore);
checkRelationshipsToStoreRulesAndDeleteOld(oldStore,newStore);
checkRelationshipToStoreAddressAndDeleteOld(oldStore,newStore);
checkRelationshipsToSecuredProductsAndDeleteOld(oldStore,newStore);
checkRelationshipsToSecurityDevicesAndDeleteOld(oldStore,newStore);
};

var checkRelationshipsToFloorsAndDeleteOld=function checkRelationshipsToFloorsAndDeleteOld(oldStore,newStore){
var existingFloorsForStore=oldStore.floorIds;
var newFloorIds=newStore.floors;

if(!existingFloorsForStore){
return;
}else if(!newFloorIds){
existingFloorsForStore.delete();
return;
}

existingFloorsForStore.
filter(function(floor){return!newFloorIds.includes(floor.id);}).
delete();
};

var checkRelationshipsToAreasAndDeleteOld=function checkRelationshipsToAreasAndDeleteOld(oldStore,newStore){
var existingAreasForStore=oldStore.areaIds;
var newAreaIds=newStore.areas;

if(!existingAreasForStore){
return;
}else if(!newAreaIds){
existingAreasForStore.delete();
return;
}

existingAreasForStore.filter(function(area){return!newAreaIds.includes(area.id);}).delete();
};

var checkRelationshipsToFixturesAndDeleteOld=function checkRelationshipsToFixturesAndDeleteOld(oldStore,newStore){
var existingFixturesForStore=oldStore.fixtureIds;
var newFixtureIds=newStore.fixtures;

if(!existingFixturesForStore){
return;
}else if(!newFixtureIds){
existingFixturesForStore.delete();
return;
}

existingFixturesForStore.
filter(function(fixture){return!newFixtureIds.includes(fixture.id);}).
delete();
};

var checkRelationshipsToStoreRulesAndDeleteOld=function checkRelationshipsToStoreRulesAndDeleteOld(oldStore,newStore){
var existingStoreRulesForStore=oldStore.storeRuleIds;
var newStoreRuleIds=newStore.storeRules;

if(!existingStoreRulesForStore){
return;
}else if(!newStoreRuleIds){
existingStoreRulesForStore.delete();
return;
}

existingStoreRulesForStore.
filter(function(storeRule){return!newStoreRuleIds.includes(storeRule.id);}).
delete();
};

var checkRelationshipToStoreAddressAndDeleteOld=function checkRelationshipToStoreAddressAndDeleteOld(oldStore,newStore){
var existingStoreAddress=oldStore.addressId;
var newStoreAddress=newStore.address;

if(!existingStoreAddress){
return;
}

if(!newStoreAddress||existingStoreAddress.id!==newStoreAddress.id){
existingStoreAddress.delete();
}
};

var checkRelationshipsToSecuredProductsAndDeleteOld=function checkRelationshipsToSecuredProductsAndDeleteOld(
oldStore,
newStore)
{
var existingProducts=oldStore.securedProductIds;
var newProducts=newStore.securedProducts;

if(!existingProducts){
return;
}else if(!newProducts){
existingProducts.delete();
return;
}

existingProducts.
filter(function(product){return!newProducts.includes(product.id);}).
delete();
};

var checkRelationshipsToSecurityDevicesAndDeleteOld=function checkRelationshipsToSecurityDevicesAndDeleteOld(
oldStore,
newStore)
{
var existingDevises=oldStore.securityDeviceIds;
var newDevises=newStore.securityDevices;

if(!existingDevises){
return;
}else if(!newDevises){
existingDevises.delete();
return;
}

existingDevises.filter(function(product){return!newDevises.includes(product.id);}).delete();
};

var deleteRelatedChilds=function deleteRelatedChilds(store){
store.floorIds&&store.floorIds.delete();
store.areaIds&&store.areaIds.delete();
store.fixtureIds&&store.fixtureIds.delete();
store.storeRuleIds&&store.storeRuleIds.delete();
store.addressId&&store.addressId.delete();
store.securedProductIds&&store.securedProductIds.delete();
store.securityDeviceIds&&store.securityDeviceIds.delete();
};